import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {useLayoutEffect, useState} from 'react';
import {useGlobals} from '../../../providers/globalPropsProvider';
import {AddToCartButtonDataHook} from '../AddToCartButton/AddToCartButton';

export function useStickyVisibility() {
  const {addToCartState} = useGlobals();
  const [isInViewPort, setIsInViewPort] = useState(true);

  useLayoutEffect(() => {
    const button = document.querySelector(`[data-hook="${AddToCartButtonDataHook.Button}"]`);

    if (!button) {
      setIsInViewPort(false);
      return;
    }

    const observer = new IntersectionObserver(([entry]) => setIsInViewPort(entry.isIntersecting), {threshold: 0.1});
    observer.observe(button);
    return () => observer.disconnect();
  }, []);

  const isAddToCartClickable = [AddToCartState.ENABLED, AddToCartState.PRE_ORDER].includes(addToCartState);

  return !isInViewPort && isAddToCartClickable;
}
